import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { RideGlHospitalSolid, RideGlPinSolid, RideGlDown } from '@rimac-seguros/ride-system-components';

import useResize from '../../../hooks/useResize';
import { getTagActionName } from '../../../utils/analytics';

const ClinicCard = ({ title, list, isToggle }) => {
  const [open, setOpen] = useState(false);
  const [width] = useResize();

  const handleClickOpen = () => {
    if (!open) {
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Modal - Lista de clínicas', `Provincia - ${title}`, 'trackAction');
    }
    setOpen(!open);
  };

  return isToggle ? (
    <div className={`clinic-card-toggle ${open ? 'open' : ''}`}>
      <div className="clinic-card-toggle_head" onClick={handleClickOpen}>
        <RideGlPinSolid size="x-large" />
        <h4>{title}</h4>
        <div className="clinic-card-toggle_head-arrow">
          <RideGlDown size={width < 1024 ? 'medium' : 'x-large'} className="arrow" />
        </div>
      </div>
      {open && (
        <div className="clinic-card-toggle_body">
          <ul>
            {list.map((_) => (
              <li key={_}>{_}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  ) : (
    <div className="clinic-card-opened">
      <div className="clinic-card-opened_head">
        <RideGlHospitalSolid size={width < 1024 ? 'medium' : '2x-large'} />
        <h4>{title}</h4>
      </div>
      <div className="clinic-card-opened_body">
        <ul>
          {list.map((_) => (
            <li key={_}>{_}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

ClinicCard.defaultProps = {
  isToggle: false,
};

ClinicCard.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  isToggle: PropTypes.bool,
};

export default ClinicCard;
